import * as _ from "lodash";

import { ExtensionBase } from "./extensionBase";
import { Misc } from "../common/misc";
import { viewerOptions } from "../viewer";
import { ViewerUtils } from "../common/viewerUtils";
import * as SmartDrawings from "../smartDrawings";
import ExternalData = SmartDrawings.ExternalData;

export class ToolTipExtension extends ExtensionBase {
    static extensionName = "ToolTipExtension";

    private extData: ExternalData;

    private foundExtData = false;
    private timeOutId;
    private objectId;
    private underMouseId;
    private toolTipField: string;
    private toolTipId: string;
    private canvas: HTMLCanvasElement;
    private currentPosition: THREE.Vector2;
    private label: HTMLElement = null;

    private tooltipTimeout = 1000;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(ToolTipExtension.extensionName, ToolTipExtension);
    }

    load(): boolean {
        console.log(`${ToolTipExtension.extensionName} is loaded!`);
        this.viewer.addEventListener(SmartDrawings.SdEvents.EXTERNAL_DATA_LOADED, this.onExternalDataLoaded);
        this.canvas = this.viewer.canvas;
        return super.load();
    }

    unload(): boolean {
        console.log(`${ToolTipExtension.extensionName} is unloaded!`);
        if (this.foundExtData) {
            this.canvas.removeEventListener("mousemove", () => { });
            this.viewer.removeEventListener(Autodesk.Viewing.OBJECT_UNDER_MOUSE_CHANGED, this.onUnderMouseChanged);
            this.viewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.onCameraChange);
        }
        return super.unload();
    }

    onExternalDataLoaded = () => {
        // External data loaded, check if tooltip field exist
        this.foundExtData = true;
        this.extData = viewerOptions.externalData;
        const propertyNames = _.keys(this.extData.propertyDefinitions);
        for (let propName of propertyNames) {
            if (this.extData.propertyDefinitions[propName]["type"] === "tooltip") {
                this.toolTipField = propName;
                this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.onCameraChange);
                this.viewer.addEventListener(Autodesk.Viewing.OBJECT_UNDER_MOUSE_CHANGED, this.onUnderMouseChanged);
                this.canvas.addEventListener("mousemove",
                    (event) => {
                        var hitTest = this.viewer.clientToWorld(event.offsetX, event.offsetY, true);
                        if (hitTest) {
                            if (this.objectId !== -1) {
                                this.currentPosition = new THREE.Vector2(event.offsetX, event.offsetY);
                            }
                        }
                    });
            }
        }

        this.viewer.removeEventListener(SmartDrawings.SdEvents.EXTERNAL_DATA_LOADED, this.onExternalDataLoaded);
    }

    onUnderMouseChanged = ({ dbId }) => {
        this.objectId = dbId;

        this.removeToolTip();

        if (dbId !== -1) {
            if (dbId !== this.underMouseId) {
                clearTimeout(this.timeOutId);
                this.timeOutId = setTimeout(async () => {
                    let tooltipText = await this.findTooltipText(dbId);
                    this.addToolTip(this.currentPosition, tooltipText);
                }, this.tooltipTimeout);
            }
        }
    }

    onCameraChange = () => {
        this.removeToolTip();
    }

    async findTooltipText(nodeId: number): Promise<string> {
        const props = this.extData.propertyValues;
        const guid = _.findKey(this.extData.paramsToDbIds, value => value === nodeId);
        if (guid) {
            if (props[guid]) {
                return props[guid][this.toolTipField];
            }
        }

        // Or try to find data in the parent.
        const parentId = await ViewerUtils.getNodeParent(nodeId, this.viewer);
        if (parentId != null) {
            return await this.findTooltipText(parentId);
        }

        return null;
    }

    addToolTip(position: THREE.Vector2, text: string) {
        if (text) {
            this.label = document.createElement("div");
            this.label.className = "tooltip-label visible";
            this.toolTipId = Misc.guid();
            this.label.id = this.toolTipId;

            const labelText = document.createElement("div");
            labelText.className = "tooltip-text pl-1 pr-2";
            labelText.innerHTML = `<pre>${_.escape(text)}</pre>`;
            this.label.appendChild(labelText);
            this.label.style.top = (position.y - this.label.getBoundingClientRect().height / 2) + "px";
            this.label.style.left = (position.x - this.label.getBoundingClientRect().width / 2) + "px";
            this.viewer.container.appendChild(this.label);
        }
    }

    removeToolTip() {
        if (this.label) {
            this.viewer.container.removeChild(this.label);
            this.label = null;
        }
    }
}